import React from 'react';

import {
  QuestionComponent,
  QuestionComponentProps
} from '../shared/QuestionComponent/QuestionComponent.react';

import FreeEntryInputArea from './V2/FreeEntryInputWrapper.react';

import './free-entry-question.scss';

const FreeEntryQuestionComponent = (props: QuestionComponentProps) => {
  return <QuestionComponent {...props} ActiveQuestionInputArea={FreeEntryInputArea} />;
};

type FreeEntryQuestionTypeProps = Omit<QuestionComponentProps, 'questionState'>;

const FreeEntryQuestion = {
  PreGuess: (props: FreeEntryQuestionTypeProps) => (
    <FreeEntryQuestionComponent {...props} questionState='PreGuess' />
  ),
  PostGuess: (props: FreeEntryQuestionTypeProps) => (
    <FreeEntryQuestionComponent {...props} questionState='PostGuess' />
  ),
  Dennis: (props: FreeEntryQuestionTypeProps) => (
    <FreeEntryQuestionComponent {...props} questionState='Dennis' />
  )
};

export {FreeEntryQuestion};
